import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionbtnComponent } from './selectionbtn.component';
import { AngularMaterialModule } from '@app/material.module';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [
        SelectionbtnComponent
    ],
    imports: [
        CommonModule,
        DirectiveModule,
        AngularMaterialModule
    ],
    exports: [
        SelectionbtnComponent
    ]
})
export class SelectionbtnModule { }
